module.exports = __webpack_public_path__ + "img/note_taker--active.1d0f1e05.svg";